/**
 * Central registry of per-user feature flag keys.
 * Each key must match the corresponding `feature_flags.key` value seeded in the
 * backend via a Flyway migration.
 *
 * Note: FRONTEND_MEASUREMENT_CALCULATION_FLAG is declared in
 * utils/measurementCalculation/types.ts alongside the types that depend on it.
 */

/** Enables creating a new project version from a market-matched configuration. */
export const MARKET_MATCH_TO_VERSION_FLAG = 'market-match-to-version';

/** Enables the (frontend-only) measurement surfaces feature: drawing calculation
 *  surfaces over the model, cutting exclusion holes, and per-surface illuminance. */
export const MEASUREMENT_SURFACES_FLAG = 'measurement-surfaces';

/** Enables client-side PDF plot generation for market-matched configurations. */
export const FRONTEND_PDF_PLOTS_FLAG = 'frontend-pdf-plots';

/** Enables the tips & tricks popup after login (first tips for new users, then one a day). */
export const TIPS_POPUP_FLAG = 'tips-popup';

/** Enables the redesigned workspace side panel: a section rail on the right edge, one
 *  scrolling panel per section and a fixed status + next-step footer. */
export const WORKSPACE_LAYOUT_V2_FLAG = 'workspace-layout-v2';

/** Enables buying subscriptions and credit packs through the payment provider, and the Billing
 *  settings section. */
export const ONLINE_PAYMENTS_FLAG = 'online-payments';

/** IDLC-1129: support contact links, choosing the photometries in the PDF export and the Pedestrian
 *  zone layer type (in the type dropdowns and name-based detection). */
export const IDLC_1129_FLAG = 'idlc-1129';

/** Enables the Drawings tab (2D plans from DWG, DXF, SVG or images) and one-step project creation. */
export const DRAWINGS_FLAG = 'drawings';
